import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchLiveReports } from '../../predict/src/core/api/reporting/report-builder';
import { queryClient } from '../core/queryClient';

type FetchLiveReportsResult = Awaited<ReturnType<typeof fetchLiveReports>>;
type LiveReportsQueryOptions = Omit<QueryObserverOptions<FetchLiveReportsResult>, 'queryKey' | 'queryFn'>;

export const liveReportsQueryKey = (organisationId: string, workspaceId: string, isConsolidation: boolean) => [
  'liveReports',
  organisationId,
  workspaceId,
  isConsolidation
];

export const liveReportsQuery = (
  workspaceId: string,
  organisationId: string,
  isConsolidation: boolean,
  options?: LiveReportsQueryOptions
): QueryObserver<FetchLiveReportsResult> =>
  new QueryObserver<FetchLiveReportsResult>(queryClient, {
    queryKey: liveReportsQueryKey(organisationId, workspaceId, isConsolidation),
    queryFn: () => fetchLiveReports(workspaceId, organisationId, isConsolidation),
    ...options
  });
